import VueCountDown from "@xkeshi/vue-countdown";


//ProgressBar
Vue.component('time-box', require('../VueComponents/Checkout/TimeBox').default);
Vue.component('steps', require('../VueComponents/Checkout/Steps-4').default);
Vue.component('steps-3', require('../VueComponents/Checkout/Steps-3').default);
Vue.component('progressbar', require('../VueComponents/Checkout/ProgressBar').default);

//SideBar
Vue.component('sidebar', require('../VueComponents/Checkout/Sidebar/SideBar').default);
Vue.component('vehicle-details', require('../VueComponents/Checkout/Sidebar/VehicleDetails').default);
Vue.component('mile-age', require('../VueComponents/Checkout/Sidebar/MileAge').default);
Vue.component('insurance-details', require('../VueComponents/Checkout/Sidebar/Insurance').default);
Vue.component('duration-details', require('../VueComponents/Checkout/Sidebar/Duration').default);
Vue.component('partner', require('../VueComponents/Checkout/Sidebar/Partner').default);
Vue.component('price-plans', require('../VueComponents/Checkout/Sidebar/PricePlans').default);

//Forms
Vue.component('handover', require('../VueComponents/Checkout/NewCustomer/Handover').default);
Vue.component('overview', require('../VueComponents/Checkout/NewCustomer/Overview').default);
Vue.component('countdown', VueCountDown);
Vue.component('form-register', require('../VueComponents/Checkout/Pages/FormRegister').default);
Vue.component('update-address', require('../VueComponents/Checkout/ExistingCustomer/UpdateAddress').default);

// Shared
Vue.component('pricing-overview', require('../VueComponents/Checkout/Shared/PricingOverview').default);
Vue.component('subscription-costs', require('../VueComponents/Checkout/Shared/SubscriptionCosts').default);
Vue.component('delivery-costs', require('../VueComponents/Checkout/Shared/DeliveryCosts').default);
Vue.component('sidebar-mobile', require('../VueComponents/Checkout/Sidebar/SidebarMobile').default);
Vue.component('mobile-title-separator', require('../VueComponents/Checkout/Shared/MobileTitleSeparator').default);
Vue.component('badge-alert', require('../VueComponents/Checkout/Sidebar/BadgeAlert').default);
Vue.component('modal-delivery-address', require('../VueComponents/Checkout/Shared/ModalDeliveryAddress').default);
Vue.component('vehicle-address', require('../VueComponents/Checkout/Shared/VehicleAddress').default);
Vue.component('pickup-address', require('../VueComponents/Checkout/Shared/PickupAddress').default);

Vue.component('stripe-credit-card-add', require('../VueComponents/Checkout/StripeCreditCardAdd').default);

// Helpers
Vue.component('spacer', require('../VueComponents/Helpers/Spacer').default);

// Pages
Vue.component('checkout-login-register', require('../VueComponents/Checkout/CheckoutLoginRegister').default);

// Form Elements
Vue.component('register', require('../VueComponents/Forms/Register').default);
Vue.component('login-form', require('../VueComponents/Forms/LoginForm').default);
Vue.component('form-hint', require('../VueComponents/Forms/Elements/FormHint').default);
Vue.component('branch-dropdown', require('../VueComponents/manufaktur/amag/BranchDropdown.vue').default)
Vue.component('pickup-address-amag', require('../VueComponents/manufaktur/amag/PickupAddressAmag.vue').default)

// New Customer
Vue.component('delivery-address-nc', require('../VueComponents/Checkout/NewCustomer/DeliveryAddressNewCustomer').default);

// Existing Customer
Vue.component('delivery-address-ec', require('../VueComponents/Checkout/ExistingCustomer/DeliveryAddressExistingCustomer').default);
Vue.component('add-payment-method-amag', require('../VueComponents/manufaktur/amag/AddPaymentMethod').default);
